import { render, staticRenderFns } from "./surgicalKit.vue?vue&type=template&id=ec18f7a8&scoped=true"
import script from "./surgicalKit.vue?vue&type=script&lang=js"
export * from "./surgicalKit.vue?vue&type=script&lang=js"
import style0 from "./surgicalKit.vue?vue&type=style&index=0&id=ec18f7a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec18f7a8",
  null
  
)

export default component.exports